// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
// import { version } from "../../package.json";
import packageInfo from '../../package.json';

export const environment = {
  production: false,
  version: packageInfo.version,
  url: window.location.href.split('/'),
  conditionFeeUrl: 'https://copyfly.es/terminos-de-servicio/',
  firebaseConfig: {
    apiKey: 'AIzaSyBgV28UTWs2Qp0q5nZZpbskXQ-82wNS3vA',
    authDomain: 'app-develop.copyfly.es',
    // authDomain: "copias-a-domicilio-develop.firebaseapp.com",
    databaseURL: 'https://copias-a-domicilio-develop.firebaseio.com',
    projectId: 'copias-a-domicilio-develop',
    storageBucket: 'copias-a-domicilio-develop.appspot.com',
    messagingSenderId: '461160713718',
    appId: '1:461160713718:web:ccf7b3d012d567f3ce4bd7',
    // measurementId: 'G-HSFRGYHE9Z'
    measurementId: "G-PFW36JCVMX"
  },
  google: {
    apiKey: 'AIzaSyBgV28UTWs2Qp0q5nZZpbskXQ-82wNS3vA',
    clientId: '461160713718-elob5iieajmli4hi12sm9pf65cuehdg8.apps.googleusercontent.com',
  },
  maps: {
    apiKey: 'AIzaSyBMdMZJSdLbT6obxcaHNlssB1l8wkBWI4Y'
  },
  appKeydropbox: 'f4t9a46k946ttuk',
  apiUrl: 'api2',
  apiFilesUrl: 'api2files',
  apiHl: 'api2hl',
  redsysUrl: 'https://sis-t.redsys.es:25443/sis/realizarPago',
  redsysScript: 'https://sis-t.redsys.es:25443/sis/NC/sandbox/redsysV3.js',
  Ds_Merchant_MerchantCode: "363749292",
  googleAnalyticsKey: 'UA-176779913-2',
  googleMerchantId: 5353837565,
  policyUrl: 'https://copyfly.es/privacidad/',
  tosUrl: 'https://copyfly.es/terminos-de-servicio/',

  rollbar: {
    accessToken: '09893d1d3fbb4c60b4f23117e4526d02'
  },
  options: {
    creatorsActive: false,
    landingShop: '/papeleria',
    categoriesFilter: true,
    vendorsFilter: false,
    featuredFilter: true,
    promotionProductSlug: 'camisetas-guay'
  },
  adobe: {
    // clientId: 'fe557e3b9b6b4c4fafb0407cfe543a44',
    clientId: '04746e8103974b22939ae8b11271720c',
  },
  encryptionKey: "A%eXc+FMSJ2VNH^9X#sIeNUx"
};
